import { cn } from "@/lib/utils";
import { useTranslations } from "next-intl";

interface FieldErrorProps {
	message?: string;
	values?: Record<string, string | number>;
	className?: string;
}

const FieldError: React.FC<FieldErrorProps> = ({ message, values, className }) => {
	if (!message) return null;

	const t = useTranslations("forms");

	return (
		<div
			data-field-error="true"
			className={cn(
				"mt-1 inline-flex w-fit items-center border px-3 py-1.5 text-xs font-medium",
				"rounded-(--ms-form-el-border-radius,var(--radius-md))",
				"[--form-error-color:var(--ms-form-el-error-color,var(--ms-color-danger))]",
				"border-(--form-error-color)/40 bg-(--form-error-color)/20 text-(--form-error-color)",
				"w-full",
				className,
			)}
		>
			{t(`validation.${message}`, values)}
		</div>
	);
};

export default FieldError;
